<div class="v-center" *ngIf="!production">
  <br/>
  <app-spinner></app-spinner>
</div>

<ng-container *ngIf="production">
  <ng-container *ngIf="!confirmationPage && showFeedTag">
      <tyt-feed-tag *ngIf="!includeShowName || !production.show">{{date | date : 'longDate'}}</tyt-feed-tag>
      <tyt-feed-tag *ngIf="includeShowName && production.show">{{production.show?.name}}, {{date | date : 'longDate'}}</tyt-feed-tag>
  </ng-container>
  <div class="production-view {{ confirmationPage? 'confirmation-page-view' : '' }} ">
    <div id="underbox">
      <h1 *ngIf="!production.show || production.show?.use_titles"><a [routerLink]="linkToWatchFirstItem">{{production.title}}</a></h1>
      <div id="metadata" *ngIf="includeTalent">
        <ng-container *ngIf="production.hosts && production.hosts.length > 0">
          <strong>Hosts:&nbsp;</strong>
          <span>
            <ng-container *ngFor="let host of production.hosts">
              <a routerLink="/about/talent/{{host.id}}">{{host.name}}</a><span class="comma"></span>
            </ng-container>
          </span>
        </ng-container>
        <ng-container *ngIf="production.guests && production.guests.length > 0">
          &nbsp;
          <strong>Guests:&nbsp;</strong>
          <span>
            <ng-container *ngFor="let guest of production.guests">
                <a>{{guest.name}}</a><span class="comma"></span>
            </ng-container>
          </span>
        </ng-container>
      </div>

      <div id="items">
        <div class="item" [class.active]="isPlaying(item)" *ngFor="let item of items">
          <ng-container *ngIf="playInline">
            <button *ngIf="!isPlaying(item)" (click)="playItem(item)" class="btn-play"><i class="fas fa-play"></i></button>
            <button *ngIf="isPlaying(item)" class="btn-playing">
              <i class="fas fa-ellipsis-h"></i>
            </button>
          </ng-container>

          <ng-container *ngIf="!playInline">
            
            <a routerLink="/{{mode == 'podcasts' ? 'listen' : 'watch'}}/{{production.show?.id || '-'}}/{{production.id}}/{{mode}}/{{item.id}}" 
               class="btn-play">
               <!-- <i class="fas fa-play"></i> -->
               <svg class="play-icon" style="width: 100%;" viewBox="0 0 31.75 22.72">
                 <g id="Layer_2" data-name="Layer 2">
                   <g id="Layer_2-2" data-name="Layer 2">
                     <path [style.fill]="sessions[item.id] && sessions[item.id].position > 5 ? '#1b75bb' : 'white'" class="cls-1" d="M31.75,22.72V0H0V22.72ZM11.54,5l10.1,6.33-10.1,6.33Z"/></g></g>
               </svg>
            
            </a>
          </ng-container>
          <div class="item-content">
            <summary>
                <ng-container *ngIf="playInline">
                    <a href="javascript:;" (click)="isPlaying(item) ? null : playItem(item)">
                      {{item.description}}
                    </a>
                </ng-container>
                <ng-container *ngIf="!playInline">
                    <a *ngIf="mode == 'episodes' || mode == 'clips'" routerLink="/{{mode == 'podcasts' ? 'listen' : 'watch'}}/{{production.id}}/{{mode}}/{{item.id}}">
                      {{item.description}}
                    </a>
                    <a *ngIf="mode != 'episodes' && mode != 'clips'" routerLink="/{{mode == 'podcasts' ? 'listen' : 'watch'}}/{{production.show?.id}}/{{production.id}}/{{mode}}/{{item.id}}">
                      {{item.description}}
                    </a>
                </ng-container>
            </summary>

            <tyt-playback-status-bar 
              (sessionChanged)="sessions[item.id] = $event"
              [item]="item" 
              [production]="production" 
              [playlist]="mode">
            </tyt-playback-status-bar>
            
            <div class="addendum">
                <div class="tyt-tags">
                  <ng-container *ngIf="item.is_premium && !item.unlock_premium">
                    <tyt-plus-tag *ngIf="audienceType === 'member'"></tyt-plus-tag>
                    <tyt-plus-locked *ngIf="audienceType !== 'member'"></tyt-plus-locked>
                  </ng-container>
                  <tyt-plus-unlocked *ngIf="item.unlock_premium"></tyt-plus-unlocked>
                </div>
                <ul class="facts">
                    <li>{{item.duration | duration}}</li>
                    <li><tyt-comments-count identifier="vod_{{item.id}}"></tyt-comments-count></li> <!-- TODO -->
                </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</ng-container>